import type { ColDef, ValueFormatterParams } from "ag-grid-community";
import type { GetPublicationsOutput } from "../../../../utils/trpc";
import { filterParams } from "./utils";

export const orgTableColDef = (publications?: GetPublicationsOutput) => {
  const baseColDef: ColDef[] = [
    { field: "name", initialSort: "asc" },
    { field: "id" },
    {
      field: "expiry",
      valueFormatter: function (params) {
        if (!params.value) {
          return "-";
        }
        return new Date(params.value).toLocaleString("en-UK", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      },
      filter: "agDateColumnFilter",
      filterParams,
    },
    {
      field: "Users",
      valueGetter: (params) => params.data.users?.length ?? 0,
    },
    {
      field: "lastModified",
      valueFormatter: function (params) {
        return new Date(params.value).toLocaleString("en-UK", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      },
      filter: "agDateColumnFilter",
      filterParams,
    },
  ];

  const publicationColDef: ColDef[] | undefined = publications
    ?.filter((pub) => pub.status === "PUBLISHED")
    .map((publication) => ({
      field: "publication-" + publication.id,
      headerName: publication.title,
      cellDataType: "boolean",
      cellRenderer: (params: ValueFormatterParams) => {
        return (
          <div className="ag-cell-wrapper ag-checkbox-cell" role="presentation">
            <div
              role="presentation"
              className="ag-labeled ag-label-align-right ag-checkbox ag-input-field ag-disabled"
            >
              <div
                className={`ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper ag-disabled ${params.value && "ag-checked"}`}
                role="presentation"
              >
                <input
                  className="ag-input-field-input ag-checkbox-input"
                  type="checkbox"
                  disabled
                  checked={!!params.value}
                />
              </div>
            </div>
          </div>
        );
      },
    }))
    .sort((a, b) =>
      a.headerName.localeCompare(b.headerName, undefined, {
        sensitivity: "base",
      }),
    );
  return [...baseColDef, ...(publicationColDef ?? [])];
};
